import { createAsyncThunk } from '@reduxjs/toolkit';
import { logger } from "helpers/logger";
import { getDashboards } from "api/dashboardApi";

// #region DASHBOARD

export const fetchDashboardsThunk = createAsyncThunk(
    'dashboard/fetchDashboardsThunk',
    async (_, { rejectWithValue, signal }) => {
        try {
            const response = await getDashboards(signal);
            return response;
        } catch (error) {
            if (error.name === 'AbortError') {
                logger.info("🚫 Request cancelled");
                return rejectWithValue("cancelled");
            }
            logger.error("❌ Failed to fetch dashboards:", error);
            return rejectWithValue(error.message || "Failed to fetch dashboards");
        }
    }
);

// #endregion